import { arrayOf, string } from 'prop-types';
import React from 'react';

import GroupSelect from '../GroupSelect';
import CategoryContext from './CategoryContext';

function CategorySelect(props) {
  const getFilteredCategories = (filteredValues, allCategories) => {
    const options = [];
    allCategories.forEach(category => {
      if (!filteredValues.includes(category.id)) {
        category.options.forEach(subCategory => {
          if (filteredValues.includes(subCategory.id)) {
            options.push(category);
          }
        });
      } else options.push(category);
    });
    return options;
  };
  return (
    <CategoryContext.Consumer>
      {categories => (
        <GroupSelect
          {...props}
          options={
            props?.filteredValues.length > 0
              ? getFilteredCategories(props.filteredValues, categories)
              : categories
          }
        />
      )}
    </CategoryContext.Consumer>
  );
}

CategorySelect.propTypes = {
  filteredValues: arrayOf(string),
};

CategorySelect.defaultProps = {
  filteredValues: [],
};

export default CategorySelect;
